import { render } from "./Referrals.vue?vue&type=template&id=7136ab80&scoped=true"
import script from "./Referrals.vue?vue&type=script&lang=js"
export * from "./Referrals.vue?vue&type=script&lang=js"

import "./Referrals.vue?vue&type=style&index=0&id=7136ab80&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7136ab80"]])

export default __exports__